(function ($) {
}(window.jQuery));

jQuery(($) => {
    let termType; let
        termLetter;

    function selectedType () {
        $('.term-type input').on('change', () => {
            termType = $('input[name=term]:checked', '.term-type').val();
            getGlossaryList(termType, termLetter);
        });
    }

    function filterLetter () {
        $('.filter-letter').on('click', function (e) {
            e.preventDefault();

            $('.term-filter .filter-letter').removeClass('current');
            $('.term-filter .filter-letter').removeAttr('aria-current');
            termLetter = $(this).data('letter');
            $(this).addClass('current');
            $(this).attr('aria-current', true);

            getGlossaryList(termType, termLetter);
        });
    }

    function getGlossaryList (type, letter) {
        const currentUrl = window.location.href;
        const url = `${currentUrl.split('&')[0]}?`;

        termType = (typeof (termType) === 'undefined' || '') ? 'null' : termType;
        termLetter = (typeof (termLetter) === 'undefined' || '') ? 'null' : termLetter;

        $.get(url, {
            type: termType,
            letter: termLetter
        }, (data) => {
            $('.ajax-list-holder').html(data);
        });
    }

    getGlossaryList();
    selectedType();
    filterLetter();
});



// WEBPACK FOOTER //
// ./src/js/app/glossary-filter.js